module.exports = __webpack_public_path__ + "assets/-_16.9ce8a9bd.svg";